import { render, staticRenderFns } from "./QuotaPlans.vue?vue&type=template&id=4c1e86e3&scoped=true"
import script from "./QuotaPlans.vue?vue&type=script&lang=js"
export * from "./QuotaPlans.vue?vue&type=script&lang=js"
import style0 from "./QuotaPlans.vue?vue&type=style&index=0&id=4c1e86e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e86e3",
  null
  
)

export default component.exports